import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function removePieceFromCarnet(carnetId, piece, prefix) {
  const token = await getOrRefreshFirebaseToken();

  const res = await axios.delete(
    `${prefix}carnets/${carnetId}/pieces/${piece}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return res.data;
}
